var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M186.963,83.922a.667.667,0,0,0-.546-.463l-4.13-.386-1.637-4.011a.678.678,0,0,0-.623-.463.592.592,0,0,0-.623.463l-1.637,4.011-4.13.386a.667.667,0,0,0-.546.463.942.942,0,0,0,.156.771l3.2,2.854-.935,4.242a.62.62,0,0,0,.312.694.586.586,0,0,0,.7,0l3.585-2.237,3.585,2.237a.589.589,0,0,0,.39.077c.156,0,.234-.077.39-.154a.834.834,0,0,0,.312-.694l-.935-4.242,3.2-2.854A1.129,1.129,0,0,0,186.963,83.922Z",
    transform: "translate(-173.061 -78.6)",
    fill: "#eddb8f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/Premium.66e65c3c.svg";
export { ForwardRef as ReactComponent };